import { getNutrimaticLabels, type NutrimaticLabels } from '@/features/locale/nutrimatic'
import { getRuntimeLocale } from '@/features/locale/runtime'

function currentLabels(): NutrimaticLabels {
  return getNutrimaticLabels(getRuntimeLocale())
}

/**
 * Etiquetas visibles del dispositivo Nutri-Matic.
 * Resuelven el idioma activo en cada acceso; la app se re-renderiza al cambiar locale.
 */
export const nutrimaticLabels = new Proxy({} as NutrimaticLabels, {
  get(_target, prop: string | symbol) {
    const labels = currentLabels()
    const value = labels[prop as keyof NutrimaticLabels]
    if (typeof value === 'function') {
      return (...args: unknown[]) => (value as (...a: unknown[]) => unknown).apply(labels, args)
    }
    return value
  },
})

export type { NutrimaticLabels }
